module.exports = __webpack_public_path__ + "img/h-1.2dbffcd8.svg";